import styled from 'styled-components'
import dragResize from '../../../../image/dragresize.svg'
import { COLORS } from '../../../../../Utils/colors'
import { convertTextAlignToFlex } from '../../../../../Utils/helpers'
import text_mask from '../../../../image/text_flow_mask.png'

function rgbaToHsl(rgba) {
  // Extract the RGBA values
  const rgbaValues = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d.]*)?\)/);
  if (!rgbaValues) {
    throw new Error('Invalid RGBA color format');
  }

  let [_, r, g, b, a] = rgbaValues;
  r = parseInt(r, 10) / 255;
  g = parseInt(g, 10) / 255;
  b = parseInt(b, 10) / 255;
  a = parseFloat(a);

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }

  h = Math.round(h * 360);
  s = Math.round(s * 100);
  l = Math.round(l * 100);

  return {
    h,
    s,
    l
  }
}



export const TextCaptionStyle = styled.span`

    display: block;
    cursor: pointer;
    left:0;
    top:0;
    width: 100%;

    .dragg{
      background-color:#f0f;
    }
`


export const GetP = props => {
  const P = styled.p`
    background-color: ${props.captionStyle.backgroundColor};
    border-style: solid;
    border-color: ${props.captionStyle.borderColor};
    border-radius: ${props.captionStyle.borderRadius}px;
    border-width: ${props.captionStyle.borderWidth}px;
    color: ${props.captionStyle.color};
    font-family: ${props.captionStyle.fontFamily};
    font-size: ${Math.floor(props.captionStyle.fontSize)}px;
    font-style: ${props.captionStyle.fontStyle};
    font-weight: ${props.captionStyle.fontWeight};
    margin: 0;
    line-height: ${props.captionStyle.lineHeight / 100 * props.captionStyle.fontSize}px;
    min-height: ${props.captionStyle.minHeight}px;
    padding: ${Math.floor(props.captionStyle.padding + props.captionStyle.diffBetwenFontSizeAndLineHeight)}px ${Math.floor(props.captionStyle.padding)}px;
    text-shadow: ${props.captionStyle.textShadow};
    text-decoration: ${!props.previewSlide ? props.captionStyle.underline : ''};
    text-align: ${props.captionStyle.textAlign};
    z-index: ${props.captionStyle.zIndex};
    width: 100%;
    word-wrap: break-word;
    white-space: pre-wrap;
    -moz-user-select: initial;
    /* для плавного ховера */
    transition: 0.25s;

    &>span>span>span>span{
      text-decoration: ${props.previewSlide ? props.captionStyle.underline : ''};
    }

    & span{
      /* тут transition добавлять нельзя для предотвращения мигания текста после анимации исчезновения */
      margin: 0 -0.1px;
    }

    & .Typewriter__cursor{
      position:absolute;
      white-space: normal !important;
    }

    &.showTextAnywayPreventAnimation {
      /* при прекращении просмотра анимации в редакторе чтобы начавшаяся анимация не смущала пользователей
      скрываем движущиеся спаны, которые добавила библиотека и показываем старый капшн, который стоит на месте*/
      opacity: 1 !important;
      span {
        display: none;
      }
      ul {
        display: block !important;
      }
    }

    &:hover{
      background-color: ${props.captionStyle.backgroundColorHover};
      border-color: ${props.captionStyle.borderColorHover};
      color: ${props.captionStyle.colorHover};
    }
`
  // const styles = {
  //   backgroundColor: `${props.captionStyle.backgroundColor}`,
  //   borderStyle: 'solid',
  //   borderColor: `${props.captionStyle.borderColor}`,
  //   borderRadius: `${props.captionStyle.borderRadius}px`,
  //   borderWidth: `${props.captionStyle.borderWidth}px`,
  //   color: `${props.captionStyle.color}`,
  //   fontFamily: `${props.captionStyle.fontFamily}`,
  //   fontSize: `${Math.floor(props.captionStyle.fontSize)}px`,
  //   fontStyle: `${props.captionStyle.fontStyle}`,
  //   fontWeight: `${props.captionStyle.fontWeight}`,
  //   margin: 0,
  //   lineHeight: `${props.captionStyle.lineHeight / 100 * props.captionStyle.fontSize}px`,
  //   minHeight: `${props.captionStyle.minHeight}px`,
  //   padding: `${Math.floor(props.captionStyle.padding + props.captionStyle.diffBetwenFontSizeAndLineHeight)}px ${Math.floor(props.captionStyle.padding)}px`,
  //   textShadow: `${props.captionStyle.textShadow}`,
  //   textDecoration: `${!props.previewSlide ? props.captionStyle.underline : ''}`,
  //   textAlign: `${props.captionStyle.textAlign}`,
  //   zIndex: `${props.captionStyle.zIndex}`,
  // }
  // return (<div/>)
  return (
    <P
      id={props.id}
      key={props.key}
      onBlur={props.onBlur}
      className={props.className}
      contentEditable={props.contentEditable}
    // style={styles}
    >
      {props.children}
    </P>
  )
}

export const TextP = styled.p`
  width: 100%;
  word-wrap: break-word;
  white-space: pre-wrap;
  -moz-user-select: initial;
  /* для плавного ховера */
  transition: 0.25s;

  /* для сафари */
  &[contenteditable] {
    -webkit-user-select: text;
    user-select: text;
  }

  @keyframes animated-text {
    100% {
      background-position: 200% 0;
    }
  }

  &.stripes-animation span {
    /* background: url('${text_mask}'); */
    /* background: linear-gradient(90deg, rgba(255, 78, 78, 1) 0%, rgba(255, 159, 67, 1) 25%, rgba(112, 251, 168, 1) 50%, rgba(76, 144, 253, 1) 75%, rgba(146, 87, 205, 1) 100%); */
    background: ${props => props.stripesColor ? props.stripesColor + ' text' : `linear-gradient(90deg, rgba(255, 78, 78, 1) 0%, rgba(255, 159, 67, 1) 20%, rgba(112, 251, 168, 1) 40%, rgba(76, 144, 253, 1) 60%, rgba(146, 87, 205, 1) 80%, rgba(255, 78, 78, 1) 100%) text`};
    background-size: 200%;
    -webkit-text-fill-color: transparent!important;
    transition: .2s;
    /* filter: ${props => `hue-rotate(${rgbaToHsl(props.color).h}deg)`}; */
    animation: animated-text ${props => `${10 / props.stripesSpeedMultiplier}s`} linear infinite;
  }

  &.stripes-animation:hover span {
    -webkit-text-fill-color: ${props => props.captionStyle.colorHover}!important;
  }

  &>span>span {
    /* display: inline-flex; */
    /* padding-left: 0.5em; */
    /* letter-spacing: -1em; */
    /* margin-right: -0.1em; */
    /* margin-right: ${props => `${-props.letterSpacing - 0.1}em`}; */
  }

  &>span>span span{
    text-decoration: ${props => props.previewSlide ? props.captionStyle.underline : ''};
    /* чтобы виден был курсивный наклонный шрифт, выходящий за границы элемента */
    outline: 20px solid transparent;
    /* letter-spacing: ${props => props.letterSpacing}; */
    /* margin-right: -0.3em; */
  /* margin-left: 0.3em; */
  }
  /* &>span>span>span>span {
    margin-left: ${props => `${+props.letterSpacing / 2}em`};
    margin-right: ${props => `${-props.letterSpacing / 2}em`};
  } */

  & span{
    /* тут transition добавлять нельзя для предотвращения мигания текста после анимации исчезновения */
    /* margin: 0 -0.1px; */
    margin: ${props => props.captionStyle.direction === 'rtl' ? '0px' : '0px -0.005em'};
    /* margin: 0px -0.005em; */
  }

  & .Typewriter__cursor{
    position:absolute;
    white-space: normal !important;
  }

  &.showTextAnywayPreventAnimation {
    /* при прекращении просмотра анимации в редакторе чтобы начавшаяся анимация не смущала пользователей
    скрываем движущиеся спаны, которые добавила библиотека и показываем старый капшн, который стоит на месте*/
    opacity: 1 !important;
    span {
      display: none;
    }
    ul {
      display: block !important;
    }
  }
/* !important для того, чтобы эти стили перебивали инлайновые в редакторе */
  &:hover{
    background-color: ${props => props.captionStyle.backgroundColorHover} !important;
    border-color: ${props => props.captionStyle.borderColorHover} !important;
    color: ${props => props.captionStyle.colorHover} !important;
  }
  &::after {
    content: ${props => props.hasAfter ? '""' : ''};
    background-color: ${props => props.captionStyle.backgroundColor};
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: -1;
    transition: .2s;
    border-radius: ${props => props.captionStyle.borderRadius}px;
  }
  &:hover::after {
    background-color: ${props => props.captionStyle.backgroundColorHover} !important;
  }
`
export const HiddenTextPLine = styled.div`
  visibility: hidden;
  word-wrap: break-word;
  white-space: pre-wrap;
`

export const CountdownContainer = styled.div`
  position: relative;
  overflow: hidden;
  transition: all 0.25s ease;
  &:hover{
    background-color: ${props => props.captionStyle.backgroundColorHover} !important;
    border-color: ${props => props.captionStyle.borderColorHover} !important;
    .contdown-item {
      color: ${props => props.captionStyle.colorHover};
    }
  }
`
export const CountdownList = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* transform: translate3d(0,0,0); */
  /* transition: transform 0.4s ease; */
  transition: top 0.4s ease;
  /* transition-property: transform; */
  /* transition-duration: 0.4s; */
  `

export const CountdownCubeList = styled.div`

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all .4s ease-in-out;
  transform-style: preserve-3d;
  transform-origin: ${props => `${props.size / 2}px ${props.size / 2}px 0`};
  perspective: 99999px;
`

export const CountdownCubeItem = styled.div`
  transform:  translateY(-50%) ${props => `rotateX(${props.index * props.directionSign * 90}deg)`} ${props => `translateZ(${props.size / 2}px)`};
  backface-visibility: hidden;
  color: ${props => props.color};
  padding: ${props => props.padding};
  position: absolute;
  width: 100%;
  visibility: hidden;
  word-wrap: break-word;
  white-space: pre-wrap;
  top: 50%;
`
// -webkit-transition: -webkit-transform 0.4s ease;
export const CountdownItem = styled.div`
  flex: 1 0 100%;
  height: 100%;
  word-wrap: break-word;
  white-space: pre-wrap;
  color: ${props => props.color};
  padding: ${props => props.padding};
  overflow: hidden;
  transition: color 0.25s ease;
  display: flex;
  align-items: center;
  justify-content: ${props => props.justifyContent};
  `
export const CountdownHidedList = styled.div`
  display: flex;
  width: 100%;
  visibility: hidden;
`
export const CountdownHidedItem = styled.div`
  flex: 1 0 100%;
  max-width: 100%;
  word-wrap: break-word;
  white-space: pre-wrap;
`

export const CreditsContainer = styled.div`
  position: relative;
  /* overflow: hidden; */
  &:hover{
    background-color: ${props => props.captionStyle.isHover ? props.captionStyle.backgroundColorHover : ''} !important;
    border-color: ${props => props.captionStyle.isHover ? props.captionStyle.borderColorHover : ''} !important;
    .credits-content, .credits-item-visible {
      color: ${props => props.captionStyle.isHover ? props.captionStyle.colorHover || props.captionStyle.fontColorHover : ''}!important;
    }
  }
`

export const CreditsItem = styled.div`
  position: absolute;
  flex: 1 0 100%;
  width: 100%;
  color: ${props => props.color};
  padding: ${props => props.padding};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
export const CreditsHiddenList = styled.div`
  display: flex;
  width: 100%;
  visibility: hidden;
`

export const CreditsItemContent = styled.div`
  opacity: 0;
  transform: ${props => props.direction === 'forward' ? `scale(0)` : `scale(2)`};
  transition: .5s;
  filter: blur(5px);
  pointer-events: none;
  &.playing {
    animation: blurFadeInOut 3s ease-in backwards;
  }
  &.playing-forward {
    animation: blurFadeInOutForward 3s ease-in backwards;
  }
`

export const ButtonCaptionStyle = styled.span`
    display: block;
    cursor: pointer;
    left:0;
    top:0;
    .caption-content{
      /* библтотека hvr добаляет display: inline-block; что вызывает нежелательные отступы сверху и снизу в мобильном виде */
      display: block;
      width: 100%;
      border: solid;
      margin: 0;
      overflow: hidden;
      white-space: pre-wrap;
      word-wrap: break-word;
      /* тут нельзя ставить transition для opacity, т.к. при анимации кнопки плавно исчезают в то время, когда их видно не должно быть */
      transition-property: ${props => !props.isGradient ? 'color, border-color, transform, background' : 'color, border-color, transform'} ;
      transition-duration: .5s;

      -moz-user-select: initial;
    }
    .caption-content[contenteditable] {
      -webkit-user-select: text;
      user-select: text;
    }
    .no-transition {
      transition: none !important;
    }

    .caption-content {
      /* transform: none !important; */
      /* transition: ${props => props.hoverAnimationType === 'background' && !props.isGradient ? '.5s' : 'none'}; */
      /* transition: ${props => props.buttonAnimationOn ? '' : '.35s'}; */
      color: ${props => !props.editingText ? props.textColor : ''};
    }
    .caption-content:before {
      ${props => props.editingText ? 'display: none;' : ''}
      /* z-index: 1 !important; */
      backface-visibility: hidden;
      overflow: ${props => props.hoverAnimationType == 'background' ? 'hidden' : 'visible'};
    }


      .caption-content:hover{
        background: ${props => ((props.hoverAnimationType != 'anti-hover' && props.hoverAnimationType != 'background') && !props.editingText) ? props.backgroundColorHover : ''}!important;
        ${props => !props.editingText ? 'border-color: ' + props.borderColorHover + ' !important' : ''};
        ${props => !props.editingText ? 'color: ' + props.textColorHover + ' !important' : ''};
        /* если для кнопки добавлен ховер, то она при анимации плавно исчезает, когда её не должно быть видно */
      }
      .button-text {
        color: ${props => props.textColorHover} !important;
      }

    .caption-content::before{
      background: ${props => {
    if (props.hoverAnimationType === 'background') {
      if (props.backgroundColorHover) {
        return props.backgroundColorHover
      } else {
        return '#2098D1'
      }
    } else {
      // на самом деле тут передаётся BGcolor который без ховера, 
      // т.к. псевдоэлемент расположен над BG и убирается по ховеру
      return props.backgroundColorHover
    }
  }}!important;
    }

    i {
      text-decoration: none !important;
    }

`

export const ButtonContentContainer = styled.p`
  display: ${props => props.iconOn ? 'flex!important' : 'block!important'};
  align-items: center;
  justify-content: ${props => props.textAlign ? convertTextAlignToFlex(props.textAlign, props.iconLocation == 'right') : 'center'};
  flex-direction: ${props => props.iconLocation == 'left' ? 'row' : 'row-reverse'};
  * {
    position: relative;
    z-index: 2;
  }
`

export const ButtonText = styled.div`
  position: absolute;
  display: ${props => props.iconOn ? 'flex!important' : 'block!important'};
  align-items: center;
  justify-content: ${props => props.textAlign ? convertTextAlignToFlex(props.textAlign, props.iconLocation == 'right') : 'center'};
  flex-direction: ${props => props.iconLocation == 'left' ? 'row' : 'row-reverse'};
  top: 0;
  /* bottom: 0; */
  left: 0;
  right: 0;
  z-index: 10;
  width: 100%;
  /* height: 100%; */
  border: solid;
  border-color: transparent;
  pointer-events: none;
  overflow: hidden;
  transition: color .5s ease;
  white-space: pre-wrap;
  word-wrap: break-word;
`


export const BoxCaptionStyle = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  /* // выделение капч внутри бокса */
  cursor: grab;
  ${props => props.effectType === 'backdrop' && !props.hasCustomShape ? `backdrop-filter: blur(${props.glassEffect}px) invert(${props.invertEffect}) grayscale(${props.grayscaleEffect});` : ``}
  ${props => props.effectType === 'backdrop' ? `border-top-left-radius: ${props.borderRadius.leftTop}px;
        border-top-right-radius: ${props.borderRadius.rightTop}px;
        border-bottom-left-radius: ${props.borderRadius.leftBottom}px;
        border-bottom-right-radius: ${props.borderRadius.rightBottom}px;` : ''}
  /* выделит бокс, в который можно поместить перетаскиваемый элемент */
  &.drop-in-me>div>div>div.box-border {
    &:before {
      box-shadow: inset 0 0 3px 3px rgba(0,0,0,1);
      display: block;
      content: 'drop to drop';
      /* width: 90px; */
      /* height: 15px; */
      position: absolute;
      /* top: 50%;
      left: 50%;
      transform: translate(-50%, -50%); */
      color: #fff;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      border-top-left-radius: ${props => props.borderRadius.leftTop}px;
      border-top-right-radius: ${props => props.borderRadius.rightTop}px;
      border-bottom-left-radius: ${props => props.borderRadius.leftBottom}px;
      border-bottom-right-radius: ${props => props.borderRadius.rightBottom}px;
    }
  }
  
  &>.selected-border>:first-child>.box-border{
    /* если position: relative, то тень закрывает outline */
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;      
    /* box-shadow: ${props => props.shadow}; */
    height: 100%;
    /* .pencil {
      display:none;
    }      
    .curve {
      display:none;
    } */
    opacity: ${props => props.opacity};
    padding: ${props => props.borderWidth}px;
    border-top-left-radius: ${props => props.borderRadius.leftTop}px;
    border-top-right-radius: ${props => props.borderRadius.rightTop}px;
    border-bottom-left-radius: ${props => props.borderRadius.leftBottom}px;
    border-bottom-right-radius: ${props => props.borderRadius.rightBottom}px;
    &:active{
      opacity: .5;
    }
    &:after {
      box-sizing: border-box;
      display: block;
      content: ${props => props.hasCustomShape ? '' : '""'};
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      ${props => props.effectType === 'element' ? `filter: blur(${props.blur}px);` : ``}
      background: ${props => {
    if (typeof props.backgroundColor === 'string') {
      return props.backgroundColor
    }
    else if (props.backgroundColor.type === 'color') {
      return props.backgroundColor.colorValue;
    } else {
      let gradient = '';
      props.backgroundColor.gradientLayers.map((layer, index) => {
        gradient = `linear-gradient(${layer.angle}deg, ${layer.firstColor}, ${layer.secondColor} ${layer.transition}%)` + gradient
        if (index != props.backgroundColor.gradientLayers.length - 1) {
          gradient = ', ' + gradient
        }
      })
      return gradient
    }
  }};
      border: ${props => Math.round(props.borderWidth)}px solid ${props => props.borderColor};
      border-top-left-radius: ${props => Math.round(props.borderRadius.leftTop)}px;
      border-top-right-radius: ${props => Math.round(props.borderRadius.rightTop)}px;
      border-bottom-left-radius: ${props => Math.round(props.borderRadius.leftBottom)}px;
      border-bottom-right-radius: ${props => Math.round(props.borderRadius.rightBottom)}px;
      box-shadow: ${props => props.shadow};
      z-index: -1;
      background-repeat: no-repeat;
    }

    
  }
  
  &>.selected-border>:first-child>.box-border>.caption-content{
      width: 100%;
      height: 100%;
      /* &:active{
        opacity:0.5
      } */
      
      border-top-left-radius: ${props => props.borderRadius.leftTop}px;
      border-top-right-radius: ${props => props.borderRadius.rightTop}px;
      border-bottom-left-radius: ${props => props.borderRadius.leftBottom}px;
      border-bottom-right-radius: ${props => props.borderRadius.rightBottom}px;
      /* background-color: ${props => props.backgroundColor}; */
    }
    .caption-box-shape {
    ${props => `filter: blur(${props.blur}px);`}
  }
`

const defaultResizePinStyle = {
  backgroundColor: '#ffffff',
  // right: '-5px',
  // top: '50%',
  // transform: 'translateY(-50%)',
  border: `1px solid ${COLORS.deepBlue}`,
  width: `10px`,
  height: `10px`,
  borderRadius: '50%',
  zIndex: '999'
}

const defaultResizeHandleStyle = {
  zIndex: '998',
}

export const ResizeHandleWrapper = styled.div`
  .react-resizable-handle-right, .react-resizable-handle-left, .react-resizable-handle-top, .react-resizable-handle-bottom {
    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(${props => 1 / props.viewScale});
      width: 10px;
      height: 10px;
      background-color: #ffffff;
      border: 1px solid ${COLORS.deepBlue};
      border-radius: 50%;
      z-index: 9;
    }
  }
`

export const rightResizeHandleStyle = (scale) => ({
  ...defaultResizePinStyle,
  top: '50%',
  transform: `translateY(-50%) scale(${1 / scale})`,
})

export const rightLineResizeHandleStyle = (scale) => ({
  ...defaultResizeHandleStyle,
  right: `-3px`,
  border: `1px solid transparent`,
  width: `6px`,
  height: `100%`,
  top: '0%'
})

export const leftLineResizeHandleStyle = (scale) => ({
  ...defaultResizeHandleStyle,
  left: `-3px`,
  border: `1px solid transparent`,
  width: `6px`,
  height: `100%`,
  top: '0%'
})

export const topLineResizeHandleStyle = (scale) => ({
  ...defaultResizeHandleStyle,
  top: `-3px`,
  border: `1px solid transparent`,
  width: `100%`,
  height: `6px`,
  left: `0%`
})

export const bottomLineResizeHandleStyle = (scale) => ({
  ...defaultResizeHandleStyle,
  bottom: `-3px`,
  border: `1px solid transparent`,
  width: `100%`,
  height: `6px`,
  left: `0%`
})

export const leftResizeHandleStyle = (scale) => ({
  ...defaultResizePinStyle,
  top: '50%',
  transform: `translateY(-50%) scale(${1 / scale})`,
})

export const topResizeHandleStyle = (scale) => ({
  ...defaultResizePinStyle,
  left: '50%',
  transform: `translateX(-50%) scale(${1 / scale})`,
})

export const bottomResizeHandleStyle = (scale) => ({
  ...defaultResizePinStyle,
  left: '50%',
  transform: `translateX(-50%) scale(${1 / scale})`,
})

export const bottomRightResizeHandleStyle = (scale) => ({
  ...defaultResizePinStyle,
  transform: `translate(-50%, -50%) scale(${1 / scale})`
})

export const bottomLeftResizeHandleStyle = (scale) => ({
  ...defaultResizePinStyle,
  transform: `translate(50%, -50%) scale(${1 / scale})`
})

export const topLeftResizeHandleStyle = (scale) => ({
  ...defaultResizePinStyle,
  transform: `translate(50%, 50%) scale(${1 / scale})`
})

export const topRightResizeHandleStyle = (scale) => ({
  ...defaultResizePinStyle,
  transform: `translate(-50%, 50%) scale(${1 / scale})`
})



// export const BoxTools = styled.div`
//   .pencil{
//     display: flex;
//     position: absolute;
//     justify-content: center;
//     top: -37px;
//     right: 0px;
//     box-shadow: 0 2px 6px 0 rgba(22, 45, 61, 0.55);
//     min-width: 32px;
//     cursor: pointer;
//     color: ${props => props.boxFigureIsEdit ? '#fff' : '#2d4150'};
//     background-color: ${props => props.boxFigureIsEdit ? '#3899ec' : '#f8f8f8'};
//     border: ${props => props.boxFigureIsEdit ? '2px solid #fff' : ''};
//     border-radius: 17px;
//     line-height: ${props => props.boxFigureIsEdit ? 28 : 32}px;
//     text-align: center;
//     display: inline-block;
//     font-size: 16px;
//     transform: ${props => props.boxFigureIsEdit ? 'rotateY(360deg)' : ''};
//     transition: ${props => props.boxFigureIsEdit ? '.6s' : 0};
//     z-index: 2;
//     &:hover{
//       color: ${props => props.boxFigureIsEdit ? '' : '#3899ec'};
//     }
//   }

//   .curve{
//     display: flex;
//     position: absolute;
//     justify-content: center;
//     top: -37px;
//     right: 0px;
//     box-shadow: 0 2px 6px 0 rgba(22, 45, 61, 0.55);
//     min-width: 32px;
//     cursor: pointer;
//     color: ${props => props.needShowCurve ? '#fff' : '#2d4150'};
//     background-color: ${props => props.needShowCurve ? '#3899ec' : '#f8f8f8'};
//     border: 2px solid #fff;
//     border-radius: 17px;
//     line-height: 28px;
//     text-align: center;
//     display: inline-block;
//     font-size: 16px;
//     transform: ${props => props.boxFigureIsEdit ? 'translateX(-40px)' : ''};
//     transition: ${props => (props.boxFigureIsEdit) ? '.6s' : 0};
//     opacity: ${props => props.boxFigureIsEdit ? '1' : '0'};
//     z-index: 1;
//     &:hover{
//         color: ${props => props.boxFigureIsEdit ? '' : '#3899ec'};
//     }
//   }
// `